import axios from "axios";
import dayjs from "dayjs";
import i18next from "i18next";
import { get, lowerCase } from "lodash";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import FirstTable from "./components/FirstTable";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ScreenShotSection from "./components/ScreenShotSection";
import SecondTable from "./components/SecondTable";

function App() {
  const searchParams = new URLSearchParams(document.location.search);

  const [screenShot, setScreenShot] = useState("");
  const [training, setTraining] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isSlowTraining, toggleSlowTraining] = useState(false);

  let token = searchParams.get("token");
  let user_id = searchParams.get("user_id");
  let lang = searchParams.get("lang") ?? "en";
  let training_id = searchParams.get("training_id");
  let imprimable = searchParams.get("isImprimable");
  let unitSystem = searchParams.get("unit-system");
  let unitSpeed = searchParams.get("speed-unit");
  let dateFormat = searchParams.get("date_format");

  const getLink = () => {
    let link = process.env.REACT_APP_BASE_API_URL;
    link = link.replace("TRAINING_ID", training_id);
    link = link.replace("TOKEN", token);
    link = link.replace("USER_ID", user_id);
    link = link.replace("LANG", lang);
    link = link.replace("UNIT_SYSTEM", unitSystem);
    link = link.replace("SPEED_UNIT", unitSpeed);
    return link;
  };

  useEffect(() => {
    const currentLang = lowerCase(lang);
    i18next.changeLanguage(currentLang);

    // Set RTL direction based on language
    const isRtl = currentLang === "ar";
    document.documentElement.dir = isRtl ? "rtl" : "ltr";
    document.documentElement.lang = currentLang;


    setLoading(true);
    setError(null);
    axios
      .get(getLink())
      .then(({ data }) => {
        handleUserLangForScreenShot(data);
        setTraining(data);

        //Set if training is considered slow < 46
        toggleSlowTraining(data?.slow_training ?? false);
      })
      .catch((err) => {
        console.log({ err });
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleUserLangForScreenShot = (data) => {
    if (lowerCase(lang) === lowerCase("FR")) {
      setScreenShot(get(data, "training.screenshots.pdf_figure_fr_url"));
    } else if (lowerCase(lang) === lowerCase("EN")) {
      setScreenShot(get(data, "training.screenshots.pdf_figure_en_url"));
    } else {
      setScreenShot(get(data, "training.screenshots.pdf_figure_en_url"));
    }
  };
  const getDate = () => {
    return get(training, "training.creation_date")
      ? dayjs(get(training, "training.creation_date")).format(
          "DD-MM-YYYY HH:mm",
        )
      : "";
  };

  if (loading) {
    return (
      <p className="text-center mt-5 font-semibold text-lg">🔄 Chargement</p>
    );
  }

  if (error) {
    return (
      <p className="text-center mt-5 font-semibold text-lg">
        {" "}
        ⚠️ Oops une erreur est survenue
      </p>
    );
  }

  return (
    <div className="w-full">
      {/* For meta Head informations */}
      <Helmet
        title={
          get(training, "training.horse_trainer.horse.name", "-") +
          " - " +
          getDate()
        }
        meta={[{ name: "description", content: "" }]}
      ></Helmet>
      {/* ------------ */}
      {/* First page - always takes full height when printable */}
      <div
        className={isSlowTraining ? "" : "break-after-page"}
        style={
          !isSlowTraining && imprimable
            ? {
                position: "relative",
                maxHeight: "1122px",
                minHeight: "1122px",
                height: "1122px",
              }
            : {}
        }
      >
        <Header dateFormat={dateFormat} training={training} showInfo></Header>
        <div className="ps-1 pe-1">
          <div
            className="sm:w-full md:w-[793px] ms-auto me-auto relative"
            style={{
              minHeight: imprimable && !isSlowTraining ? "1122px" : "auto",
              paddingBottom: imprimable && !isSlowTraining ? "60px" : 0,
            }}
          >
            <ScreenShotSection
              imprimable={imprimable}
              screenShot={screenShot}
            />
            <FirstTable training={training} slowTraining={isSlowTraining} />
            <div
              style={{
                position:
                  !isSlowTraining && imprimable ? "absolute" : "inherit",
                bottom: !isSlowTraining && imprimable ? "10px" : "inherit",
              }}
            >
              <Footer
                training={training}
                imprimable={imprimable}
                slowTraining={isSlowTraining}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Second page - only full height if NOT slow training */}
      {get(training, "past_trainings_key_parameters", []).length > 0 && (
        <div
          className={!isSlowTraining ? "break-before-page" : ""}
          style={
            !isSlowTraining && imprimable
              ? {
                  position: "relative",
                  maxHeight: "794px",
                  minHeight: "794px",
                  height: "794px",
                }
              : {}
          }
        >
          <SecondTable
            insightItems={get(training, "insight_items", [])}
            slowTraining={isSlowTraining}
            parameters={get(training, "past_trainings_key_parameters", [])}
          >
            {imprimable === "true" && !isSlowTraining && (
              <Header
                dateFormat={dateFormat}
                training={training}
                showInfo={false}
              >
                {" "}
              </Header>
            )}
          </SecondTable>
        </div>
      )}
    </div>
  );
}

export default App;
